import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Dropdown } from 'antd';
import {
  DashboardOutlined,
  ShopOutlined,
  FileTextOutlined,
  UserOutlined,
  AppstoreOutlined,
  BookOutlined,
  BarChartOutlined,
  SettingOutlined,
  LogoutOutlined,
  GlobalOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/auth.service';
import type { MenuProps } from 'antd';
import './MainLayout.css';

const { Header, Sider, Content } = Layout;

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const languageItems: MenuProps['items'] = [
    {
      key: 'pt',
      label: 'Português',
      onClick: () => changeLanguage('pt'),
    },
    {
      key: 'en',
      label: 'English',
      onClick: () => changeLanguage('en'),
    },
  ];

  const menuItems: MenuProps['items'] = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: t('menu.dashboard'),
      onClick: () => navigate('/dashboard'),
    },
    {
      key: '/service-providers',
      icon: <ShopOutlined />,
      label: t('menu.serviceProviders'),
      onClick: () => navigate('/service-providers'),
    },
    {
      key: '/quotes',
      icon: <FileTextOutlined />,
      label: t('menu.quotes'),
      onClick: () => navigate('/quotes'),
    },
    {
      key: '/customers',
      icon: <UserOutlined />,
      label: t('menu.customers'),
      onClick: () => navigate('/customers'),
    },
    {
      key: '/products',
      icon: <AppstoreOutlined />,
      label: t('menu.products'),
      onClick: () => navigate('/products'),
    },
    {
      key: '/categories',
      icon: <BookOutlined />,
      label: t('menu.categories'),
      onClick: () => navigate('/categories'),
    },
    {
      key: '/reports',
      icon: <BarChartOutlined />,
      label: t('menu.reports'),
      onClick: () => navigate('/reports'),
    },
    {
      key: '/settings',
      icon: <SettingOutlined />,
      label: t('menu.settings'),
      onClick: () => navigate('/settings'),
    },
  ];

  const selectedKey = '/' + location.pathname.split('/').filter(Boolean)[0];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ background: '#C8CBC0' }}
      >
        <div className="logo" style={{
          padding: '24px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          background: '#C8CBC0'
        }}>
          <img
            src="/favicon.png"
            alt="DiTasq"
            style={{
              width: collapsed ? '32px' : '40px',
              height: collapsed ? '32px' : '40px',
              objectFit: 'contain'
            }}
          />
          {!collapsed && (
            <span style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#334E3B'
            }}>
              DiTasq
            </span>
          )}
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          style={{ background: '#C8CBC0', color: '#334E3B' }}
          theme="light"
        />
      </Sider>

      <Layout>
        <Header className="site-layout-header">
          <div className="header-left">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ fontSize: '16px', width: 64, height: 64 }}
            />
          </div>

          <div className="header-right">
            <Dropdown menu={{ items: languageItems }} placement="bottomRight">
              <Button type="text" icon={<GlobalOutlined />} />
            </Dropdown>

            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
            >
              {t('auth.logout')}
            </Button>
          </div>
        </Header>

        <Content className="site-layout-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
